import React, { useEffect } from 'react';
import { axiosInstance } from '../../../../api/strapi';
import { useParams, useHistory } from 'react-router-dom';
import Loader from '../../../../ui-core/Loader';

const OldBlog = () => {
  const params = useParams();
  const history = useHistory();

  const fetchData = async () => {
    try {
      let endpoint = `/blogs/${params?.id}`;
      endpoint += '?populate=*';
      const response = await axiosInstance.get(endpoint);
      if (Object.keys(response?.data?.data)?.length > 0) {
        const responseData = response?.data?.data;
        history.push(
          '/blog/' +
            params?.id +
            '/' +
            responseData?.attributes?.title
              ?.toLowerCase()
              ?.trim()
              ?.split(' ')
              ?.join('-'),
        );
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchData();
  });
  return <Loader isLoading={true} />;
};

export default OldBlog;
